require('angular');
require('angular-cookies');
require('angular-google-analytics');
require('angular-sanitize');
require('angular-touch');
require('moment/locale/fr');

// configure current project
var utils = require('walnut-common/src/modules/walnutCommon/common/utils'),
    $window = angular.injector(['ng']).get('$window'),
    appConfig = {
        analytics: {
            UA    : 'UA-128770035-12',
            domain: $window.location.hostname
        },
        debug       : true,
        defaultState: 'portail-home',
        defaultTitle: 'APP_TITLE',
        moduleId    : 'Portail',
        moduleURL   : $window.location.origin,
        servers     : {
            auth   : $window.location.origin + utils.getReplaceLast($window.location.pathname, 'auth') + '/api/',
            bandeau:
                $window.location.origin + utils.getReplaceLast($window.location.pathname, 'bandeau-caisses') + '/api/',
            param    : $window.location.origin + utils.getReplaceLast($window.location.pathname, 'parametrage') + '/api/',
            myaccount: $window.location.origin + utils.getReplaceLast($window.location.pathname, 'myaccount') + '/api/',
            lc       : 'http://localhost:8080/api/'
        },
        demo: false
    };

// additionnal dependancies with app config
require('walnut-common')(appConfig);
require('./modules/portail/index.js');

/**
 * App common run
 * @param $rootScope
 * @param WCConstants
 */
function commonRun($rootScope, WCConstants) {
    // init
    $rootScope.isMobile = WCConstants.isMobile;
}

angular
    .module('app', [
        'ngCookies',
        'ngSanitize',
        'ngTouch',
        'angular-google-analytics',
        'ui.router',
        'valdr',
        'app.walnutCommon',
        'app.portail'
    ])
    .run(commonRun);

angular.element(document).ready(function () {
    angular.bootstrap(document, ['app']);
});
